import styled, { css } from 'styled-components';
import { media } from 'utils/rwd';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const TitleWrapper = styled.div`
  background-color: rgba(255, 255, 255, 0.45);
  position: relative;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 8px;
  z-index: 10;
  ${media.xs`
    padding: 30px;
    gap: 16px;
  `}
  ${media.xl`
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  `}

  ${({ $titleSeparator }) =>
    $titleSeparator && `border-bottom: 2px solid #e9ecef; padding-bottom: 20px;`}

  ${({ $noPaddingBottom }) =>
    $noPaddingBottom &&
    css`
      padding-bottom: 0;
      ${media.xs`
        padding-bottom: 0;
      `}
    `}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: auto;

  & button {
    text-wrap: nowrap;
    white-space: nowrap;
    font-size: 10px;
  }

  ${media.sm`
    & button {
      font-size: 12px;
    }
  `}

  ${media.md`
    & button {
      font-size: 14px;
    }
  `}

  ${media.lg`
    & button {
      font-size: 16px;
    }
  `}
`;

export const HeaderTitle = styled.h1`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  ${media.xs`
    font-size: 26px;
  `}
`;

export const HeaderDescription = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  ${media.xs`
    font-size: 16px;
  `}
`;

export const AbsoluteButtonWrapper = styled.div`
  position: absolute;
  right: 30px;
  z-index: 20;
`;

export const Icon = styled.div`
  font-size: 2rem;
  display: flex;
  align-items: center;
  align-content: center;
  text-align: center;
  padding: 0.83333rem;
  justify-content: center;
  background: #fff;
  box-shadow:
    0 0.46875rem 2.1875rem rgb(4 9 20 / 3%),
    0 0.9375rem 1.40625rem rgb(4 9 20 / 3%),
    0 0.25rem 0.53125rem rgb(4 9 20 / 5%),
    0 0.125rem 0.1875rem rgb(4 9 20 / 3%);
  border-radius: 0.25rem;
  width: 60px;
  min-width: 60px;
  height: 60px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Footer = styled.div`
  z-index: 1000;
  left: 0;
  width: 100%;
  min-height: 75px;
  position: fixed;
  border-top: 2px solid #e9ecef;
  bottom: 0;
  padding: 1rem 30px;
  background-color: white;
  display: flex;
  align-items: center;
  ${media.sm`
  left: ${({ sideBarCollapsed }) => (sideBarCollapsed ? '66px' : '250px')};
  width: ${({ sideBarCollapsed }) =>
    sideBarCollapsed ? 'calc(100% - 66px)' : 'calc(100% - 250px)'};
`}
`;

export const MainContent = styled.div`
  overflow-y: auto;
  flex-grow: 1;
  padding: ${({ $skipPadding }) => ($skipPadding ? '0' : '0 30px')};
  margin-bottom: ${({ $hasFooter }) => ($hasFooter ? '76px' : '0')};
  scrollbar-gutter: stable;
`;
